var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('GroupName',{attrs:{"no-save":_vm.noSave,"errors-post":_vm.errorsPost.name || []},model:{value:(_vm.form.name),callback:function ($$v) {_vm.$set(_vm.form, "name", $$v)},expression:"form.name"}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }